import { VideoItem } from "../../Types/modeltypes"

type ApiResponse = {
    status: boolean
    data: VideoItem[]
    error?: string
}

export async function fetchVideos(): Promise<VideoItem[]> {
    try {
        const res = await fetch('/getAllVideos') // 👈 change URL


        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`)
        }

        const json: any = await res.json()

        if (!json.status) {
            throw new Error(json.error || 'API returned false')
        }

        const videoList: VideoItem[] = []
        json.data.forEach((element: any) => {
            videoList.push({
                title: element.title,
                videoUrl: `/${element.path}/${element.filename}` // 👈 IMPORTANT
            })
        })
        return videoList;

    } catch (error) {
        console.log(error)
        window.alert(error);
        return []
    }
}